// gatsby-browser.js
require('prism-themes/themes/prism-a11y-dark.css');
